import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';
import {EContactFieldType, EProjectType} from '../../../../@models';

@Component({
  selector: 'ngx-form-list-sort-field-render',
  template: '<button class="btn btn-default" (click)="onSortUp()" ' +
              '*ngIf="value > 1"><i class="ion-arrow-up-b"></i></button>' +
            '<button class="btn btn-default" (click)="onSortDown()">' +
              '<i class="ion-arrow-down-b"></i></button>', // +
  // '{{renderValue}}',
})
export class FormListSortFieldRenderComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value:  number;
  @Input() rowData: any;
  @Output() sortUp: EventEmitter<any> = new EventEmitter<any>();
  @Output() sortDown: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit() {
    this.renderValue = String(this.value);
  }

  onSortUp() {
    this.sortUp.emit(this.rowData);
  }

  onSortDown() {
    this.sortDown.emit((this.rowData))
  }

}
